module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgwIiB3aWR0aD0iNjQwIiB2aWV3Qm94PSIwIDAgNjQwIDQ4MCI+CiAgPGcgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2Utd2lkdGg9IjFwdCIgdHJhbnNmb3JtPSJzY2FsZSgxLjI1IC45Mzc1KSI+CiAgICA8cmVjdCByeD0iMCIgcnk9IjAiIGhlaWdodD0iNTA5Ljc2IiB3aWR0aD0iNTEyIiBmaWxsPSIjZmZmIi8+CiAgICA8cmVjdCByeD0iMCIgcnk9IjAiIGhlaWdodD0iMTY5LjkyIiB3aWR0aD0iNTEyIiB5PSIzNDIuMDgiIGZpbGw9IiMyMTQ2OGIiLz4KICAgIDxwYXRoIGZpbGw9IiNhZTFjMjgiIGQ9Ik0wIDBoNTEydjE2OS45MkgweiIvPgogIDwvZz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/4x3/nl.svg
// module id = ./node_modules/flag-icon-css/flags/4x3/nl.svg
// module chunks = 0